var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeSharpenerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 984.4 977",
    style: {
      enableBackground: "new 0 0 984.4 977"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#0E73F6;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M984.3,18.5L978.5,97c-0.6,8.7-8.5,15.4-17.1,14.8c-8.9-0.7-15.6-8.5-15-17.2l2.9-38.8L93.1,893.1h0.2 l744.8-251.6l35.3-429.2l0.7-0.8l34.1-33.2l-38.7,476.3c-0.1,2-0.9,4-1.8,5.7c-0.3,0.8-0.9,1.4-1.4,2.1c-0.7,0.8-1.1,1.7-2,2.5 l-0.2,0.2c0,0,0,0.2-0.2,0.2L573.7,942l39.2,2.9c8.7,0.6,15.4,8.5,14.8,17.3c-0.6,8.7-8.5,15.4-17.1,14.8l-78.6-5.8 c-4.4-0.3-8.6-2.5-11.3-5.9c-2.6-3.4-3.9-7.8-3.4-12.2l5.4-75.9c0.7-4.4,3.1-8.5,6.5-11.1c3.4-2.4,7.6-3.5,11.8-2.8 c8.6,1.2,14.7,9.2,13.7,18.1v34.4l235.2-224l-773,254.5l0,0l285.5-768L56,412.9l39.6,2.9c8.9,0.7,15.6,8.5,15,17.2 c-0.7,8.9-8.5,15.6-17.3,15L15,442.2c-4.4-0.3-8.6-2.5-11.3-5.9c-2.8-3.4-4.1-7.8-3.4-12.2L5.7,348c0.5-4.2,2.9-8.3,6.5-10.9 c3.2-2.6,7.4-3.5,11.6-2.8c8.8,1.1,14.9,9.2,13.9,17.9v34L331.6,106c0.9-0.7,1.9-1.3,2.8-2c0.6-0.2,1.1-0.7,1.7-1.1h0.2 c1.7-0.9,3.5-1.2,5.6-1.2c0.2-0.2,0.4-0.2,0.6-0.1l462.2-28.4l-38.1,34.3l-0.8,0.1l-412,25.4L69.5,871L927,32.7l-34.3-0.5l-1-0.1 c-8.3-0.6-15.1-7.8-14.8-16.3c-0.1-4.1,1.6-8,4.5-11c3.1-3,7.5-4.7,11.9-4.8l75.2,1.3c4.5-0.1,8.6,1.9,11.6,5.1 C983.1,9.7,984.6,14.1,984.3,18.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeSharpenerWhite);
export default __webpack_public_path__ + "static/media/trade_sharpener_white.b161822f29c0e0872bea07f9a71f32f7.svg";
export { ForwardRef as ReactComponent };